import styled from 'styled-components/macro'
import { orderingWidgetStyles } from '@meniudigital/shared'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .preview-section {
    background: ${props => props.theme.activeBackground};
    position: relative;
    overflow: hidden;
    background-color: ${props => props.theme.accent}44;
    padding: 16px;
    /* 376px is the widget width on an iPhone 12 Pro */
    width: calc(min(376px, 100vw - (7px * 2)));
    /* ignore padding */
    box-sizing: content-box;

    // maximum modal width is 700px
    // from this we need to subtract 32px (16px padding each side of modal)
    // and another 32px (16px padding each side of widget setting)
    // then we subtract 376px (maximum widget width)
    // and 4px for border
    // and 8px for no idea what really but we need it
    // and divide by 2 to get the left & right padding
    /* padding: 16px calc((700px - 32px - 376px - 4px - 16px) / 2); */
    padding: 16px 144px; // gets overriden anyway lol

    @media (max-width: 768px) {
      padding: 16px 7px;
      zoom: 0.996;
    }

    @media (max-width: 390px) {
      zoom: 0.89;
    }

    @media (max-width: 375px) {
      zoom: 0.86;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      box-shadow: inset 0px 0px 20px #0003;
      pointer-events: none;
      z-index: 1;
    }
  }

  .preview-label {
    text-align: center;
    font-size: 13px;
    color: ${props => props.theme.secondaryText};
    margin: 8px 24px;

    svg {
      color: ${props => props.theme.blue};
      margin-right: 4px;
      font-size: 12px;
    }
  }

  .preview-background {
    position: absolute;
    top: -10px;
    left: 0px;
    width: 100%;
    height: calc(100% + 20px);
    object-fit: cover;
    z-index: 0;
  }

  ${orderingWidgetStyles}
`
